import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal } from 'antd';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import Util from '../../../script/util';
import './MaxWill.scss';

class MaxWill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      index: 0,
    };
  }
  showModal = (data, index) => {
    this.setState({
      visible: true,
      data: data,
      index: index,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  stopParent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  changeIndex = (i) => {
    this.setState({
      index: i,
    });
  };
  changeLeft = () => {
    let { index, data } = this.state;
    if (index > 0) {
      index -= 1;
    } else {
      index = data.length - 1;
    }
    this.setState({
      index: index,
    });
  };
  changRight = () => {
    let { index, data } = this.state;
    if (index < data.length - 1) {
      index += 1;
    } else {
      index = 0;
    }
    this.setState({
      index: index,
    });
  };
  render() {
    const { visible, data, index } = this.state;
    return (
      <Modal
        open={visible}
        className="max-will-bg"
        title={null}
        footer={null}
        closable={false}
        width="100%"
        onCancel={this.hideModal}
        zIndex={1002}
      >
        {visible ? (
          <div className="max-will-bg" onClick={this.hideModal}>
            <div className="max-will-content" onClick={this.stopParent}>
              <span className="will-left" onClick={this.changeLeft}>
                <span className="icos">
                  <LeftCircleOutlined />
                </span>
              </span>
              <span className="will-right" onClick={this.changRight}>
                <span className="icos">
                  <RightCircleOutlined />
                </span>
              </span>
              <div className="all-will-list">
                <div
                  className="all-wills"
                  style={{ width: `${data.length * 700}px` }}
                >
                  {data.map((item, i) => {
                    return (
                      <span
                        className={
                          i == index ? 'will-item-bg active' : 'will-item-bg'
                        }
                        key={`will-${i}`}
                        style={{
                          backgroundImage: `url(${Util.transImgUrl(item)})`,
                        }}
                      ></span>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="max-will-step" onClick={this.stopParent}>
              {data.map((item, i) => (
                <span
                  key={`step-${i}`}
                  onClick={this.changeIndex.bind(this, i)}
                  className={index == i ? 'active' : ''}
                ></span>
              ))}
            </div>
          </div>
        ) : null}
      </Modal>
    );
  }
}

export default withRouter(MaxWill, { withRef: true });
